import { useIsSuperuser } from "hooks/users"

/**
 * Whether the user may pick a starting layout / save-as-new. Superuser-only for the MVP — a regular
 * user has one implicit layout (APP-3284). Duplicate is ungated; it never touches a layout.
 */
export function useCanManageLayouts(): boolean {
  return useIsSuperuser()
}
